import { useEffect } from 'react';

const usePreventZoom = () => {
	const keyCodes = new Set<string>(['Equal', 'Minus', 'NumpadAdd', 'NumpadSubtract']);

	const handleKeyDown = (e: KeyboardEvent) => {
		if (e.ctrlKey && keyCodes.has(e.code)) {
			e.preventDefault();
		}
	};

	const handleWheel = (e: WheelEvent) => {
		if (e.ctrlKey) {
			e.preventDefault();
		}
	};

	useEffect(() => {
		document.addEventListener('keydown', handleKeyDown);
		document.addEventListener('wheel', handleWheel, { passive: false });

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
			document.removeEventListener('wheel', handleWheel);
		};
	}, []);
};

export default usePreventZoom;
